import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIImage from 'UIComponents/image/UIImage';
// @ts-expect-error static asset
import templateMarketplaceImageUrl from 'bender-url!../../img/asset-marketplace-themes-1x.png';
// @ts-expect-error static asset
import templateMarketplaceImageUrl2x from 'bender-url!../../img/asset-marketplace-themes-2x.png';
import { getTemplateMarketplaceUrl } from '../utils/urls';
import MediaSection from './MediaSection';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AssetMarketplaceSection({
  className,
  onTrackInteraction
}) {
  return /*#__PURE__*/_jsx(MediaSection, {
    button: /*#__PURE__*/_jsx(UIButton, {
      href: getTemplateMarketplaceUrl(),
      onClick: () => onTrackInteraction('click asset marketplace section button'),
      use: "tertiary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceUnified.sections.templateMarketplace.buttonText"
      })
    }),
    className: className,
    "data-test-id": "asset-marketplace-section",
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplaceUnified.sections.templateMarketplace.description"
    }),
    media: /*#__PURE__*/_jsx(UIImage, {
      src: templateMarketplaceImageUrl,
      srcSet: `${templateMarketplaceImageUrl2x} 2x`,
      style: {
        width: '100%',
        maxWidth: 500
      }
    }),
    orientation: "media-left",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplaceUnified.sections.templateMarketplace.title"
    })
  });
}